import React, { useState, useEffect, useCallback } from "react";
import "../css/others/Table.css";
import Pagination from "../Reusablecomponents/Pagination";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import ToastPopup from "../popups/ToastPopup";
import { FunctionData, FunctionEnum, createToastMessage, ToastMessage } from '../interFaces/interfaces';
const AddFunctions: React.FC = () => {
    const [data, setData] = useState<FunctionData[]>([]);
    const [, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(10);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [message, setMessage] = useState<ToastMessage | null>(null);
    const [selectedRows, setSelectedRows] = useState<Set<string>>(new Set());
    const [functionEnums, setFunctionEnums] = useState<FunctionEnum[]>([]);
    const clientId = localStorage.getItem("clientId");
    const columns = [{ key: "functionName", label: "Function Name" }, { key: "functionHeadName", label: "Function Head Name" }, { key: "functionHeadEmail", label: "Function Head Email" }, { key: "functionSpocName", label: "Function Spoc Name" }, { key: "functionSpocEmail", label: "Function Spoc Email" }, { key: "createdBy", label: "Created By" }, { key: "createdDate", label: "Created Date" },];
    useEffect(() => {
        const fetchFunctionEnums = async () => {
            try {
                const response = await apiCall("get", "/api/enums/FunctionEnum");
                setFunctionEnums(response || []);
            } catch (error) {
                console.error("Error fetching function enums:", error);
            }
        };
        fetchFunctionEnums();
    }, []);
    const getFunctionDescription = (value: string) => {
        const enumItem = functionEnums.find(item => item.value === value);
        return enumItem ? enumItem.description : value || "N/A";
    };
    const formatDate = (dateString: string | undefined | null): string => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    const fetchFunctions = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiCall("get", `/api/functions?status=INACTIVE&page=${currentPage - 1}&size=${itemsPerPage}&clientId=${clientId}`);
            setData(response?.content || []);
            setTotalPages(response?.totalPages || 0);
            setTotalElements(response?.totalElements || 0);
        } catch (error) {
            console.error("Error fetching functions:", error);
        } finally {
            setLoading(false);
        }
    }, [clientId, currentPage, itemsPerPage]);
    useEffect(() => { fetchFunctions() }, [fetchFunctions]);
    const handleRowSelect = (functionId: string) => {
        setSelectedRows(prev => {
            const newSelection = new Set(prev);
            if (newSelection.has(functionId)) {
                newSelection.delete(functionId);
            } else {
                newSelection.add(functionId);
            }
            return newSelection;
        });
    };
    const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            const allIds = data.map(func => func.functionId);
            setSelectedRows(new Set(allIds));
        } else {
            setSelectedRows(new Set());
        }
    };
    const handleAddFunction = async () => {
        if (selectedRows.size === 0) {
            setMessage(createToastMessage("Please select at least one function", "error", 3000));
            return;
        }
        try {
            const functionIds = [...selectedRows];
            await apiCall("patch", `/api/functions?status=ACTIVE`, functionIds);
            setMessage(createToastMessage("Functions added successfully!", "success", 3000));
            setSelectedRows(new Set());
            fetchFunctions();
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || "Failed to add functions";
            setMessage(createToastMessage(errorMessage, "error", 3000));
        }
    };
    return (
        <div className="table-details">
            <div className="table-title">
                <h2>Add Functions</h2>
                <div className="table-title-actions">
                    {selectedRows.size > 0 && (
                        <button className="campaign-create" onClick={handleAddFunction}>Add Selected Functions</button>
                    )}
                </div>
            </div>
            <div>
                <div className="table-container">
                    <div className="table-inner-container">
                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>
                                        <input type="checkbox" onChange={handleSelectAll} checked={selectedRows.size === data.length && data.length > 0} />
                                    </th>
                                    {columns.map((column) => (
                                        <th key={column.key}>{column.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((func) => (
                                        <tr key={func.functionId}>
                                            <td>
                                                <input type="checkbox" checked={selectedRows.has(func.functionId)} onChange={() => handleRowSelect(func.functionId)} />
                                            </td>
                                            <td>{getFunctionDescription(func.functionName || "N/A")}</td>
                                            <td>{func.functionHeadName || "N/A"}</td>
                                            <td>{func.functionHeadEmail || "N/A"}</td>
                                            <td>{func.functionSpocName || "N/A"}</td>
                                            <td>{func.functionSpocEmail || "N/A"}</td>
                                            <td>{func.createdBy || "N/A"}</td>
                                            <td>{formatDate(func.createdDate) || "N/A"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={columns.length + 1} className="no-data">No functions found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
            {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}        </div>
    );
};
export default AddFunctions;